import React, { useEffect, useState } from 'react';
import articlesData from '../../data/articles.js'

import classes from './Articles.module.scss';

//Article component
import Article from './Article/Article'

const Articles = ({...props}) => {
	//Get the article name request from the URL:
	let articleNameUrl = props.match.params.articleTitle;
	let [articleContent, setArticleContent] = useState(articlesData.articles.find( article => article.url === articleNameUrl ? article: ''))
	
	useEffect(() => {
		setArticleContent(articlesData.articles.find( article => article.url === articleNameUrl ? article: ''))
	},[props.match.params.articleTitle])
	return(
		<div className={classes.Articles}>
			<Article windowSize={props.windowSize} globalJSON={props.globalJSON} globalContent={props.globalContent} content={articleContent}></Article>
		</div>
	)

}

export default Articles;